/**
 * @file 扶持计划的表单申请
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {List, InputItem} from 'antd-mobile';
import {Select} from '../numberOptions/formCom';
import {fetchCmsapiIndexData, fetchUserApply} from '../../actions/applyAction';

import './index.less';

const textAreaList = [
    {label: '智能硬件“安全+”', value: '智能硬件“安全+”'},
    {label: '个人信息保护', value: '个人信息保护'},
    {label: '远程办公守护（WAF+VPN）', value: '远程办公守护（WAF+VPN）'},
    {label: '公益平台保护', value: '公益平台保护'},
    {label: '云加速SCDN', value: '云加速SCDN'},
    {label: '业务风控', value: '业务风控'},
    {label: 'APP消息推送', value: 'APP消息推送'}
];
class Apply extends Component {
    static propTypes = {
        fetchCmsapiIndexData: PropTypes.func,
        fetchUserApply: PropTypes.func,
        userApplyData: PropTypes.object,
        cmsapiUserapply: PropTypes.object,
        userLoginstate: PropTypes.object,
        match: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            overallTypeIndex: 2,    // 身份类型
            enterpriseName: '',  // 企业名称
            codeVal: '',
            enterpriseNameError: false,
            userNameError: false,
            codeError: false,
            userName: '',   // 真实姓名
            hasError: false,
            userPhoneVal: '', // 电话号码
            userEmailVal: '', // 邮箱
            workId: [this.props.match.params.Iid], // 感兴趣的业务
            overallTextarea: textAreaList[0].value, // 咨询内容
            userPhoneError: false,
            desInfoError: false,
            userPhoneErrorHint: '手机号码不能为空',
            userEmailError: false,
            userEmailErrorHint: '联系邮箱不能为空',
            codeImg: '/catpcha',
            codeHint: '验证码不能为空',
            from: this.getRequest().from
        };
        this.overallType = [
            {val: '企业', id: 2},
            {val: '个人', id: 1}
        ];
    }

    componentWillMount() {
        if (this.isPC()) {
            let str = '/?showPlanForm=open';
            let Iid = this.props.match.params.Iid;
            let from = this.state.from;


            if (Iid) {
                str = `/page/${Iid}?showPlanForm=open`;
            }

            if (Iid && from) {
                str = `/page/${Iid}?showPlanForm=open&from=${from}`;
            }

            if (!Iid && from) {
                str = `/?showPlanForm=open&from=${from}`;
            }
            location.href = str;
        }
    }

    userPhoneChange = val => {
        let fruit = false;
        let hint = '';
        if (this.isEmpty(val)) {
            hint = '电话号码不能为空';
            fruit = this.isEmpty(val);
        } else if (!this.isPhone(val)) {
            hint = '电话号码格式不正确，请确认';
            fruit = !this.isPhone(val);
        }
        this.setState({
            userPhoneError: fruit,
            userPhoneVal: val,
            userPhoneErrorHint: hint
        });
        return !fruit;
    };

    userEmailChange = val => {
        let fruit = false;
        let hint = '';
        if (this.isEmpty(val)) {
            hint = '邮箱不能为空';
            fruit = this.isEmpty(val);
        } else if (!this.isEmail(val)) {
            hint = '邮箱格式不正确，请确认';
            fruit = !this.isEmail(val);
        }
        this.setState({
            userEmailError: fruit,
            userEmailVal: val,
            userEmailErrorHint: hint
        });
        return !fruit;
    };

    submitFun = () => {
        let {
            overallTypeIndex,
            enterpriseName,
            userName,
            userPhoneVal,
            userEmailVal,
            overallTextarea,
            codeVal,
            from
        } = this.state;
        this.setState({
            enterpriseNameError: this.isEmpty(enterpriseName),
            userNameError: this.isEmpty(userName),
            codeError: this.isEmpty(codeVal),
            codeHint: this.isEmpty(codeVal) ? '验证码不能为空' : ''
        });
        this.userPhoneChange(userPhoneVal);
        this.userEmailChange(userEmailVal);
        if (!this.isEmpty(userName)
            && this.userPhoneChange(userPhoneVal)
            && this.userEmailChange(userEmailVal)
            && !this.isEmpty(codeVal)) {

            if (overallTypeIndex === 2) {
                if (this.isEmpty(enterpriseName)) {
                    return;
                }
            }

            let json = {
                'company_name': enterpriseName,
                'real_name': userName,
                'phone_number': userPhoneVal.replace(/\s+/g, ''),
                'email': userEmailVal.replace(/\s+/g, ''),
                'id_type': overallTypeIndex,
                'note': (overallTextarea || '') + '-扶持计划专项',
                'catpcha': codeVal,
                'from': from
            };

            if (overallTypeIndex === 1) {
                delete json['company_name'];
            }

            this.props.fetchUserApply(json).then(() => {
                const cmsapiUserapply = this.props.cmsapiUserapply;
                if (location.href.indexOf('testError') !== -1) {
                    alert(cmsapiUserapply.msg);
                }
                if (cmsapiUserapply.is_error === 0) {
                    if (from) {
                        location.href = `/m/apply-succ?from=${from}`;
                    } else {
                        location.href = '/m/apply-succ';
                    }
                }

                if (cmsapiUserapply.is_error === 3) {
                    this.setState({
                        codeError: true,
                        codeHint: '验证码不正确',
                        codeImg: `/catpcha?t=${Date.now()}`
                    });
                }
            });
        }
    };

    isEmpty = val => {
        let reg = /\S/;
        return !reg.test(val);
    };

    isEmail = val => {
        let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        let value = val.replace(/\s/g, '');
        return reg.test(value);
    };

    render() {
        let {
            overallTypeIndex,
            enterpriseNameError,
            overallTextarea,
            userNameError,
            codeError,
            userPhoneError,
            userEmailError,
            userPhoneErrorHint,
            userEmailErrorHint,
            codeHint,
            codeImg
        } = this.state;

        let enterpriseClass = classnames({
            'input-disable': overallTypeIndex === 1,
            'on': enterpriseNameError && overallTypeIndex !== 1
        });

        return (
            <div className={'apply'}>
                <h2>
                    申请表单
                </h2>
                <div className={'spu-apply-from'}>
                    <form>
                        <List>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 身份类型：
                            </div>
                            <div className={'apply-form-assist'}>
                                {this.overallType.map((item, index) => {
                                    return <div
                                        className={'overall-type-box'}
                                        key={index}
                                        onClick={() => {
                                            this.setState({
                                                overallTypeIndex: item.id
                                            });
                                        }}
                                    >
                                        <span className={overallTypeIndex === item.id ? 'on' : ''}></span>
                                        <span>{item.val}</span>
                                    </div>;
                                })
                                }
                            </div>
                        </List>

                        <List className={enterpriseClass}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 企业名称：
                            </div>
                            <InputItem
                                placeholder="请输入真实企业名称"
                                disabled={overallTypeIndex === 1}
                                onBlur={val => {
                                    this.setState({
                                        enterpriseName: val
                                    });
                                }}

                            />
                            <div className={'apply-error-hint'}>企业名称不能为空</div>
                        </List>

                        <List className={userNameError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 真实姓名：
                            </div>
                            <InputItem
                                placeholder="请输入真实姓名便于联系"
                                onBlur={val => {
                                    this.setState({
                                        userName: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>真实姓名不能为空</div>
                        </List>

                        <List className={userPhoneError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 电话号码：
                            </div>
                            <InputItem
                                type={'phone'}
                                placeholder="请输入真实电话号码便于联系"
                                onChange={val => {
                                    this.setState({
                                        userPhoneVal: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>
                                {userPhoneErrorHint}
                            </div>
                        </List>

                        <List className={userEmailError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 邮箱：
                            </div>
                            <InputItem
                                type={'email'}
                                placeholder="请输入真实邮箱便于联系"
                                onChange={val => {
                                    this.setState({
                                        userEmailVal: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>
                                {userEmailErrorHint}
                            </div>
                        </List>

                        <List>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span>申请服务：
                            </div>
                            <Select
                                placeholder="申请服务"
                                value={overallTextarea}
                                onChange={value => {
                                    this.setState({overallTextarea: value});
                                }}
                                data={textAreaList}
                            />
                            <div className={'apply-error-hint'}></div>
                        </List>

                        <List className={codeError ? 'codeInput on' : 'codeInput'}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 验证码：
                            </div>
                            <InputItem
                                placeholder="请输出右侧验证码"
                                onChange={val => {
                                    this.setState({
                                        codeVal: val,
                                        codeError: !val.replace(/\s+/g, '')
                                    });
                                }}
                            />
                            <div
                                className="overall-code"
                                onClick={() => {
                                    this.setState({
                                        codeImg: ''
                                    }, () => {
                                        this.setState({
                                            codeImg: '/catpcha'
                                        });
                                    });
                                }}
                            >
                                <img src={codeImg} alt="" height="100%"/>
                            </div>
                            <div className={'apply-error-hint'}>
                                {codeHint}
                            </div>
                        </List>

                    </form>
                </div>
                <div className={'apply-subbtn'} onClick={this.submitFun}>
                    提交
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        userApplyData: state.userApplyData,
        cmsapiUserapply: state.cmsapiUserapply
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiIndexData: () => fetchCmsapiIndexData(dispatch),
        fetchUserApply: obj => fetchUserApply(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Apply);



// WEBPACK FOOTER //
// ./src/containers/apply_plan/index.js